import React, { useState, useEffect } from "react";
import { Menu, X, ArrowRight } from "lucide-react";
import freshmentLogo from "../../../images/freshmentLogo1.png";
import { Link, useLocation } from "react-router-dom";

export default function Navbar({ onSupportClick }) {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const currentPath = location.pathname || "/";

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0); // Reset scroll position when page changes
    setIsOpen(false);
  }, [location.pathname]);

  const navLinks = [
    { label: "Home", href: "/" },
    { label: "Platform", href: "/about-edu" },
    { label: "About Us", href: "/about-us" },
    { label: "Support", href: "/support" },
  ];

  return (
    <nav
      className="fixed-top"
      style={{
        ...styles.nav,
        ...(scrolled ? styles.navScrolled : styles.navTransparent),
      }}
    >
      <div className="container ">
        <div
          className="d-flex align-items-center justify-content-between"
          style={{ height: "80px" }}
        >
          {/* Logo */}
          <Link
            to="/"
            className="d-flex align-items-center text-decoration-none"
            style={{ gap: "0.625rem" }}
          >
            {/* 
            <div style={styles.logoBox}>
              <Sparkles style={{ width: "18px", height: "18px", color: "#fff" }} />
            </div>
            <div className="d-flex flex-column">
              <span className="font-display" style={styles.logoText}>EduConnectPro</span>
              <span className="font-mono" style={styles.logoSubtext}>PLACEMENT SAAS</span>
            </div>
            */}
            <img
              src={freshmentLogo}
              alt="Freshment Logo"
              style={{ height: "40px", width: "auto", objectFit: "contain" }}
            />
          </Link>

          {/* Desktop Navigation */}
          <div
            className="d-none d-lg-flex align-items-center"
            style={{ gap: "0.25rem" }}
          >
            {navLinks.map((link) => {
              const isActive = currentPath === link.href;
              return (
                <Link
                  className="navLinkHover"
                  key={link.label}
                  to={link.href}
                  style={{
                    ...styles.navLink,
                    ...(isActive
                      ? styles.navLinkActive
                      : styles.navLinkInactive),
                  }}
                >
                  {link.label}
                </Link>
              );
            })}
          </div>

          {/* Right Side Actions */}
          <div className="d-flex align-items-center" style={{ gap: "0.75rem" }}>
            {/* Desktop Auth CTA */}
            <Link
              to="/about-edu"
              className="d-none d-lg-flex align-items-center ctaButton"
              style={styles.ctaButton}
            >
              <span>Schedule Demo</span>
              <ArrowRight
                style={{ width: "14px", height: "14px", marginLeft: "6px" }}
              />
            </Link>
            <style>
              {`
              .ctaButton:hover{
                background-color: #e04f0f !important;
              }
            `}
            </style>

            {/* Support Button - inline with navbar */}
            {/* {onSupportClick && (
              <div
                onClick={onSupportClick}
                className="navbar-support-btn"
                style={{ cursor: "pointer" }}
              >
                <div className="bg-gradient-btn navbar-support-icon">
                  <div style={{ display: "flex", alignItems: "center", flexShrink: 0 }}>
                    <svg
                      enableBackground="new 0 0 512 512"
                      height="22"
                      viewBox="0 0 512 512"
                      width="22"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="#fff"
                    >
                      <g>
                        <path d="m483.637 213.16c-10.222-6.317-21.601-7.603-31.637-6.615v-10.545c0-107.799-88.214-196-196-196-107.799 0-196 88.214-196 196v10.545c-10.036-.989-21.416.298-31.637 6.615-18.821 11.632-28.363 36.139-28.363 72.84 0 36.762 9.56 61.399 28.415 73.228 9.366 5.876 20.304 7.917 31.585 6.947v10.825c0 8.284 6.716 15 15 15h60c8.284 0 15-6.716 15-15v-181c0-8.284-6.716-15-15-15h-44.315c7.608-84.529 78.839-151 165.315-151s157.707 66.471 165.315 151h-44.315c-8.284 0-15 6.716-15 15v181c0 8.284 6.716 15 15 15h45v15c0 24.813-20.187 45-45 45h-48.58c-6.192-17.458-22.865-30-42.42-30h-30c-24.813 0-45 20.187-45 45s20.187 45 45 45h30c19.555 0 36.228-12.542 42.42-30h48.58c41.355 0 75-33.645 75-75 0-18.271 0-28.969 0-40.826 11.282.97 22.221-1.072 31.585-6.947 18.855-11.828 28.415-36.465 28.415-73.227 0-36.701-9.542-61.208-28.363-72.84zm-423.637 122.821c-4.786.833-10.768.891-15.642-2.167-9.259-5.808-14.358-22.789-14.358-47.814 0-24.785 4.985-41.569 14.036-47.259 4.894-3.077 11.06-2.858 15.964-1.89zm60-124.981v151h-30v-151zm166 271h-30c-8.271 0-15-6.729-15-15s6.729-15 15-15h30c8.271 0 15 6.729 15 15s-6.729 15-15 15zm136-120h-30v-151h30zm45.749-28.253c-4.848 3.095-10.896 3.035-15.749 2.194v-99.089c4.904-.968 11.069-1.187 15.964 1.89 9.051 5.689 14.036 22.473 14.036 47.258 0 24.923-5.062 41.88-14.251 47.747z"></path>
                      </g>
                    </svg>
                  </div>
                  <span className="ml-2 text-white navbar-support-text">
                    <span className="letter">S</span>
                    <span className="letter">U</span>
                    <span className="letter">P</span>
                    <span className="letter">P</span>
                    <span className="letter">O</span>
                    <span className="letter">R</span>
                    <span className="letter">T</span>
                  </span>
                </div>
              </div>
            )} */}

            {/* Mobile Menu Button */}
            <div className="d-lg-none">
              <button
                onClick={() => setIsOpen(!isOpen)}
                style={styles.menuButton}
              >
                {isOpen ? (
                  <X style={{ width: "20px", height: "20px" }} />
                ) : (
                  <Menu style={{ width: "20px", height: "20px" }} />
                )}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Drawer Navigation */}
      {isOpen && (
        <div className="d-lg-none" style={styles.mobileDrawer}>
          <div className="d-flex flex-column" style={{ gap: "0.25rem" }}>
            {navLinks.map((link) => {
              const isActive = currentPath === link.href;
              return (
                <Link
                  className="navLinkHover"
                  key={link.label}
                  to={link.href}
                  onClick={() => setIsOpen(false)}
                  style={{
                    ...styles.mobileNavLink,
                    ...(isActive
                      ? styles.navLinkActive
                      : styles.navLinkInactive),
                  }}
                >
                  {link.label}
                </Link>
              );
            })}
          </div>

          <div className="d-flex flex-column" style={styles.mobileCtaWrapper}>
            <Link
              to="/about-edu"
              onClick={() => setIsOpen(false)}
              className="d-flex align-items-center justify-content-center"
              style={styles.mobileCtaButton}
            >
              <span>Schedule Demo</span>
              <ArrowRight
                style={{ width: "14px", height: "14px", marginLeft: "6px" }}
              />
            </Link>
          </div>
        </div>
      )}
      <style>{`
     .navLinkHover:hover {
 background-color: oklch(0.96 0 0) !important;
    `}</style>
    </nav>
  );
}

const styles = {
  nav: {
    top: 0,
    left: 0,
    right: 0,
    zIndex: 50,
    transition: "all 0.3s ease",
    fontFamily: "sans-serif",
  },
  navScrolled: {
    backgroundColor: "white",
    backdropFilter: "blur(12px)",
    borderBottom: "1px solid #e2e8f0",
    boxShadow: "0 1px 2px 0 rgba(0,0,0,0.05)",
  },
  navTransparent: {
    backgroundColor: "rgb(248, 250, 252)",
    borderBottom: "1px solid transparent",
  },
  logoBox: {
    width: "36px",
    height: "36px",
    borderRadius: "0.75rem",
    backgroundColor: "#FF5F14",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 10px 15px -3px rgba(255, 95, 20, 0.2)",
  },
  logoText: {
    fontSize: "1rem",
    fontWeight: 700,
    color: "#0f172a",
    letterSpacing: "-0.025em",
    lineHeight: 1,
  },
  logoSubtext: {
    fontSize: "9px",
    fontFamily: "monospace",
    color: "#FF5F14",
    fontWeight: 700,
    letterSpacing: "0.1em",
    textTransform: "uppercase",
    marginTop: "2px",
    lineHeight: 1,
  },
  navLink: {
    padding: "0.5rem 1rem",
    borderRadius: "0.5rem",
    fontSize: "0.75rem",
    fontWeight: 700,
    letterSpacing: "0.05em",
    textTransform: "uppercase",
    transition: "all 0.2s ease",
    textDecoration: "none",
  },
  navLinkActive: {
    color: "#FF5F14",
    backgroundColor: "rgba(255, 95, 20, 0.05)",
  },
  navLinkInactive: {
    color: "#475569",
    backgroundColor: "transparent",
  },
  ctaButton: {
    padding: "0.625rem 1.25rem",
    borderRadius: "0.75rem",
    backgroundColor: "#FF5F14",
    color: "#fff",
    fontSize: "0.75rem",
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: "0.05em",
    boxShadow: "0 4px 6px -1px rgba(255, 95, 20, 0.1)",
    textDecoration: "none",
    cursor: "pointer",
  },
  menuButton: {
    padding: "0.5rem",
    borderRadius: "0.5rem",
    color: "#64748b",
    backgroundColor: "transparent",
    border: "none",
    cursor: "pointer",
  },
  mobileDrawer: {
    backgroundColor: "#fff",
    borderBottom: "1px solid #e2e8f0",
    padding: "1rem",
    boxShadow: "0 20px 25px -5px rgba(0,0,0,0.1)",
  },
  mobileNavLink: {
    display: "block",
    padding: "0.625rem 1rem",
    borderRadius: "0.5rem",
    fontSize: "0.75rem",
    fontWeight: 700,
    letterSpacing: "0.05em",
    textTransform: "uppercase",
    textDecoration: "none",
  },
  mobileCtaWrapper: {
    borderTop: "1px solid #f1f5f9",
    paddingTop: "0.75rem",
    marginTop: "0.75rem",
    gap: "0.5rem",
  },
  mobileCtaButton: {
    width: "100%",
    textAlign: "center",
    padding: "0.75rem",
    borderRadius: "0.75rem",
    backgroundColor: "#FF5F14",
    color: "#fff",
    fontSize: "0.75rem",
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: "0.05em",
    textDecoration: "none",
  },
};
